module.exports = __webpack_public_path__ + "static/bg-image-sailing-310849de2b378996b7a232ce5d842491.jpg";